export const FETCH_LAST_DATA_FFD_SLEEP_INIT = 'FETCH_LAST_DATA_FFD_SLEEP_INIT';
export const FETCH_LAST_DATA_FFD_SLEEP_SUCCESS = 'FETCH_LAST_DATA_FFD_SLEEP_SUCCESS';
export const FETCH_LAST_DATA_FFD_SLEEP_FAILURE = 'FETCH_LAST_DATA_FFD_SLEEP_FAILURE';

export const FETCH_LAST_DATA_FFD_SLEEP_COUNT_INIT = 'FETCH_LAST_DATA_FFD_SLEEP_COUNT_INIT';
export const FETCH_LAST_DATA_FFD_SLEEP_COUNT_SUCCESS = 'FETCH_LAST_DATA_FFD_SLEEP_COUNT_SUCCESS';
export const FETCH_LAST_DATA_FFD_SLEEP_COUNT_FAILURE = 'FETCH_LAST_DATA_FFD_SLEEP_COUNT_FAILURE';

export const FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_INIT = 'FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_INIT';
export const FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_SUCCESS = 'FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_SUCCESS';
export const FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_FAILURE = 'FETCH_LAST_DATA_FFD_SLEEP_NO_LOADING_FAILURE';

export const SET_FILTER_LAST_DATA_FFD_SLEEP = 'SET_FILTER_LAST_DATA_FFD_SLEEP';
export const RESET_LAST_DATA_FFD_SLEEP = 'RESET_LAST_DATA_FFD_SLEEP';


// WEBPACK FOOTER //
// ./source/client/actions/last_data_ffd_sleep/types.js